/* eslint-disable */

// ** React Imports
/* eslint-disable  */
import { Fragment } from "react";
import { useSelector } from "react-redux";

// ** Custom Components
/* eslint-disable  */

import NavbarUser from "./NavbarUser";
import NavbarBookmarks from "./NavbarBookmarks";

import StatsHorizontal from "@components/widgets/stats/StatsHorizontal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ThemeNavbar = (props) => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props;
  const store = useSelector((state) => state.order);

  return (
    <Fragment>
      <div className="bookmark-wrapper d-flex align-items-center">
        <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
        {/* this is my nav stats */}
        {/* <span  > {store.metaData && store?.metaData?.totalItems
                    ? store?.metaData?.totalItems
                    : 0}</span> */}
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
      
    </Fragment>
  );
};

export default ThemeNavbar;
